import React from 'react';
import '../../assets/components/mask.scss';

const Mask = ({chatListOpen, closeMessenger}) => {
  return (
    <div className={`mask ${chatListOpen ? '' : 'mask_hidden'}`} onClick={closeMessenger}></div>
  );
};

export default Mask;